import {
  Autocomplete,
  Box,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import React from "react";

const ListReviewer = ({
  loading,
  input,
  setInput,
  dataIdamanUser,
  setIdamanUsers,
  setDataIdamanUser,
}) => {
  return (
    <Box
      style={{
        px: 5,
        pb: 5,
        borderRadius: 10,
        display: "block",
        backgroundColor: "#fff",
      }}
    >
      <h3 style={{ textAlign: "center", paddingTop: 20 }}>LIST REVIEWER</h3>
      <Table>
        <TableHead>
          <TableCell></TableCell>
          <TableCell>Email</TableCell>
          <TableCell>Nama Pegawai</TableCell>
          <TableCell>Jabatan</TableCell>
          <TableCell>Fungsi</TableCell>
        </TableHead>
        <TableBody>
          {input.listApproval?.map((o, idx) => (
            <TableRow key={idx}>
              <>
                <TableCell>
                  <FormControl fullWidth>
                    <Autocomplete
                      options={dataIdamanUser}
                      getOptionLabel={(opt) => opt.namalengkap}
                      renderInput={(params) => (
                        <TextField {...params} label="Search user name" />
                      )}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.defaultPrevented = true;
                          setIdamanUsers(e.target.value);
                        }
                      }}
                      onChange={(e, value) => {
                        let listApproval = [...input.listApproval];
                        listApproval[idx] = {
                          ...listApproval[idx],
                          displayName: value.namalengkap,
                          emailUser: value.email,
                          jabatanUser: value.jabatan,
                        };
                        setInput((prev) => ({
                          ...prev,
                          listApproval,
                        }));
                        setDataIdamanUser([]);
                      }}
                      noOptionsText="Type employee name and press enter to search"
                      loadingText="searching..."
                      loading={loading}
                    />
                  </FormControl>
                </TableCell>
                <TableCell>{o.emailUser}</TableCell>
                <TableCell>{o.displayName}</TableCell>
                <TableCell>{o.jabatanUser}</TableCell>
                <TableCell>{o.approvalRole}</TableCell>
              </>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
};

export default ListReviewer;
